export default "__VITE_ASSET__DZR$0hHE__"